import { ComponentsOverrides, Theme } from "@mui/material";

const badge = (): ComponentsOverrides<Theme>["MuiBadge"] => {
    return {
        badge: {
            fontFamily: "RoobertCEZ",
            fontWeight: 600,
            fontSize: "10px",
            letterSpacing: " 0.4px",
            textTransform: "uppercase",
            width: "auto",
            height: "16px",
            lineHeight: "16px",
            minWidth: "16px",
            padding: "2px",
        },
        // TODO : dořešit
        // colorPrimary: {
        //  color: palette.white,
        // },
    };
};

export default badge;
